import { getActiveClasses } from './active-classes';
export default getActiveClasses;
